import { useState } from 'react'
import { EuiFieldText } from '@equipmentshare/ds2'
import FormRow from 'components/FormRow'
import { EmailInputProps } from './types'

export default function EmailInputEui( {
	label,
	value,
	onChange,
	onBlur,
	placeholder = '',
	isInvalid = false,
	error,
	helpText,
}: EmailInputProps ) {
	const [ hasBlurred, setHasBlurred ] = useState( false )

	const handleBlur = () => {
		setHasBlurred( true )
		if ( onBlur ) {
			onBlur( value )
		}
	}

	// Only show validation errors after the user has blurred the field
	const shouldShowError = hasBlurred && isInvalid

	return (
		<FormRow
			label={label}
			isInvalid={shouldShowError}
			error={shouldShowError ? error : undefined}
			helpText={helpText}
			fullWidth
		>
			<EuiFieldText
				placeholder={placeholder}
				value={value}
				onChange={( e ) => onChange( e?.target?.value ?? '' )}
				onBlur={handleBlur}
				isInvalid={shouldShowError}
			/>
		</FormRow>
	)
}
